import React from "react";
import PropTypes from "prop-types";
import searchIcon from "./assets/icon_search.png";
import { t } from "./i18n";
import "./Search.less";

const index = ({ onSearch }) => {
  return (
    <div className="search">
      <div>
        <img src={searchIcon} alt="" />
        <input
          placeholder={t("common.pleaseInput")}
          onFocus={() => {
            onSearch();
          }}
        />
      </div>
    </div>
  );
};

index.propTypes = {};

export default index;
